import React from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../../../../components/Button";

const ConfirmModals = ({
  showSaveAllModal,
  setShowSaveAllModal,
  handleSaveAllPurchases,
  showSuccessModal,
  setShowSuccessModal,
  showConfirm,
  setShowConfirm,
  isEditing,
  loadingSubmit,
  vendors,
  formData,
}) => {
  return (
    <>
      <Modal
        show={showSaveAllModal}
        onHide={() => setShowSaveAllModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Save</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to save all vendor purchases to Tally?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowSaveAllModal(false)}
          >
            Cancel
          </Button>
          <Button variant="success" onClick={handleSaveAllPurchases}>
            Yes, Save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div className="mb-3">
            <i
              className="bi bi-check-circle-fill text-success"
              style={{ fontSize: "3rem" }}
            />
          </div>
          <h5>Saved Successfully!</h5>
          <p className="text-muted mb-0">
            Your changes have been saved successfully.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={() => setShowSuccessModal(false)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>

      {showConfirm && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {isEditing ? "Confirm Update" : "Confirm Purchase Entry"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowConfirm(false)}
                  disabled={loadingSubmit}
                />
              </div>
              <div className="modal-body">
                <p>Are you sure you want to save this purchase entry?</p>
                <p className="mb-0">
                  <strong>Vendors:</strong> {vendors.length} |
                  <strong> Purchase Invoice No:</strong>{" "}
                  {formData.purchase_invoice_number}
                </p>
              </div>
              <div className="modal-footer">
                <Button
                  className="btn btn-secondary"
                  onClick={() => setShowConfirm(false)}
                  disabled={loadingSubmit}
                  text="No"
                />
                <Button
                  className="btn btn-primary"
                  disabled={loadingSubmit}
                  text={loadingSubmit ? "Saving..." : "Yes, Save"}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConfirmModals;
